export var EM_DASH = '—';